import { useGetTransactionsQuery } from "../features/tron-wallet/tronWalletSlice";
import { stringReduce } from "../utils/stringReduce";

export const RecentTronTransactions = () => {

    const { data: transactions } = useGetTransactionsQuery();

    return (
        <div className='bg-black flex flex-col gap-4 px-4 lg:px-10 py-10 mt-6' >
            <div className='relative flex justify-between'>
                <h3 className='text-indigo-500 text-xl font-medium'>
                    Transaction History (TRX)
                </h3>
            </div>

            <div className='overflow-x-auto relative'>
                <table className='w-full text-sm text-left text-gray-400'>
                    <thead className='text-xs uppercase bg-gray-700 text-gray-300'>
                        <tr>
                            <th scope='col' className='py-3 px-6'>
                                Transaction ID
                            </th>
                            <th scope='col' className='py-3 px-6'>
                                Type
                            </th>
                            <th scope='col' className='py-3 px-6'>
                                Address
                            </th>
                            <th scope='col' className='py-3 px-6'>
                                Amount
                            </th>
                            <th scope='col' className='py-3 px-6'>
                                Time
                            </th>
                            <th scope='col' className='py-3 px-6 w-200'>
                                Fee
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {transactions?.map((data: any, index: number) => {
                            const address = data?.type == "sent" ? data?.to : data?.type == "received" ? data?.from : ""

                            return (
                                <tr
                                    className='border-b bg-transparent border-gray-700'
                                    key={index}
                                >
                                    <th
                                        scope='row'
                                        className='py-4 px-6 font-medium whitespace-nowrap text-white'
                                    >
                                        <a href={`https://tronscan.org/#/transaction/${data.txID}`} target="_blank">
                                            {stringReduce(data.txID)}
                                        </a>
                                    </th>
                                    <td className='py-4 px-6'>{data.type}</td>

                                    <td className='py-4 px-6'><a href={`https://tronscan.org/#/address/${address}`} target="_blank">
                                        {stringReduce(address)}
                                    </a></td>
                                    <td className='py-4 px-6'>{Number(data.amount || 0) / 1000000} TRX</td>
                                    <td className='py-4 px-6'>{new Date(data.timestamp).toUTCString()}</td>
                                    <td className='py-4 px-6 w-40'>
                                        <div className='badge-error px-4 py-2 rounded-full'>
                                            {data.fee / 1000000} TRX
                                        </div>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}